import React, { Suspense, lazy } from "react";
import PropTypes from "prop-types";
import { Box, CircularProgress } from "@mui/material";

const SyncedMetricCharts = lazy(() => import("./SyncedMetricCharts"));

function LazySyncedMetricCharts(props) {
  return (
    <Suspense
      fallback={
        <Box
          sx={{
            minHeight: 300,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress size={26} />
        </Box>
      }
    >
      <SyncedMetricCharts {...props} />
    </Suspense>
  );
}

LazySyncedMetricCharts.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  groupId: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(["offSoil", "onSoil"]).isRequired,
};

export default LazySyncedMetricCharts;
